module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Code/Commit-97ae520bec48f3437118c73e0707c4f8.svg";